import http from './httpRequest';
function getSetting() {
    if(!window.settings.settingsInitFlag){
      return window.settings
    }
    let url = '/basic/buildConfig/frontList'
    http({
      url: url,
      method: 'post',
      data: {
        filter: {
          tenantId: process.env.VUE_APP_tradeOrgId || '', // '0' 查询通用数据
          releCommon: true,
        }
      },
      baseURL: '/sso',
    }).then(({ data }) => {
        var rows = data.rows || data || [];
        if (rows.length) {
          rows.forEach((item) => {
          if (item.openFlag) { // 过滤未开启的
            // type '0':'图片',  '1':'文章',  '2':'html源码',
            var html = item.content;
            if (item.type == '0' || item.type == '1') {
              html = html.replace(/<p>/g, "");
              html = html.replace(/<\/p>/g, "");
              html = html.replace(/<img src="/g, "");
              html = html.replace(/">/g, "");
            }
            if (item.type == '2') {
              html = html.replace(/<pre class="ql-syntax" spellcheck="false">/g, "");
              html = html.replace(/<\/pre>/g, "");
              html = html.replace(/&lt;/g, "<");
              html = html.replace(/&gt;/g, ">");
            }
             window.settings[item.location] = html;
          }
        })
        window.settings.settingsInitFlag = false;
        }
    })
    return  window.settings
}
function loadScript(url, callback,attributeConf) {
    // 检查是否已加载
    const existingScript = document.querySelector(`script[src="${url}"]`);
    if (existingScript) {
        console.log(`脚本已加载: ${url}`, 'info');
        if (callback) callback();
        return;
    }

    console.log(`开始加载脚本: ${url}`, 'info');

    const script = document.createElement('script');
    script.src = url;
    if(attributeConf){
        for(var key in attributeConf){
            script.setAttribute(key, attributeConf[key]);
        }
    }
    script.type = 'text/javascript';

    // 兼容IE的事件处理
    if (script.readyState) { // IE
        script.onreadystatechange = function () {
            if (script.readyState === 'loaded' || script.readyState === 'complete') {
                script.onreadystatechange = null;
                console.log(`脚本加载成功 (IE): ${url}`, 'success');
                if (callback) callback();
            }
        };
    } else { // 其他浏览器
        script.onload = function () {
            console.log(`脚本加载成功: ${url}`, 'success');
            if (callback) callback();
        };
    }

    // 错误处理
    script.onerror = function () {
        console.log(`脚本加载失败: ${url}`, 'error');
    };

    // 添加到文档
    document.head.appendChild(script);
}
export {
    getSetting,
    loadScript
}
